/**
 * US phone numbers (2026-11-02). Takes whatever they typed, (555) 123-4567,
 * 555.123.4567, +1 555 123 4567, and gives back +15551234567, or null if
 * it isn't 10 digits (11 with a leading 1).
 */
export function toE164(raw: string): string | null {
  const d = raw.replace(/\D/g, '');
  if (d.length === 10) return `+1${d}`;
  if (d.length === 11 && d.startsWith('1')) return `+${d}`;
  return null;
}
